import { http } from '../http';

export const updateUserNotificationSubscriptionService = async (payload) => {
  const url = '/users/settings/toggle_notification_subscription';
  const baseURL = process.env.BFFV2_BASE_URL;
  const response = await http.post(url, payload, { baseURL });
  if (response?.status !== 201) {
    throw new Error('something went wrong');
  }
  return response?.data;
};

export default {
  updateUserNotificationSubscriptionService,
};
